export const environment = {
	production: true,
	backendURL: "https://api-jodigi.jofalat.hu",
	isExternal: true,
};
